import React from 'react'
import AppShowCaseCard from './AppShowCaseSlider'
import { StyleContentWrapper } from '@pages/front/commons/ContentWrapper/style'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import AppShowCaseSlider from './AppShowCaseSlider'
import { TextWrapper } from '@pages/front/commons/Text'

const title = 'Designed for Simplicity, Built for You'
const subtitle = `"A clean, intuitive interface designed for effortless navigation. From booking consultations to
managing medications, everything is just a tap away."`

const AppShowCase = () => {
  return (
    <>
      <StyleContentWrapper
        bgColor="#d5edf5"
        paddingTop="50"
        paddingBottom="30"
        paddingLeft="55"
        paddingRight="55"
      >
        <TextWrapper title={title} subtitle={subtitle} textWidth="700" />
        <AppShowCaseSlider />
      </StyleContentWrapper>
    </>
  )
}

export default AppShowCase
